// extracted by mini-css-extract-plugin
export var banner = "exercise-atlas-module--banner--dc6bf";
export var filters = "exercise-atlas-module--filters--190b6";
export var list = "exercise-atlas-module--list--8aada";
export var loaderWrapper = "exercise-atlas-module--loader-wrapper--35378";
export var userCant = "exercise-atlas-module--user-cant--141b9";
export var userCantButtons = "exercise-atlas-module--user-cant-buttons--cb734";
export var userCantText = "exercise-atlas-module--user-cant-text--72f65";
export var wrapper = "exercise-atlas-module--wrapper--21c29";